import { CheckOutlined, CloseOutlined, FileOutlined, RollbackOutlined } from "@ant-design/icons"
import {
  List,
  Descriptions,
  Button,
  Space,
  Popconfirm,
  Typography,
  Progress,
  Divider,
  Popover,
} from "antd"
import { addDoc, collection, deleteDoc, doc, serverTimestamp, updateDoc } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { Notification } from "../../Notification"
import moment from "moment"
import { Link as Direction } from "react-router-dom"
import { useAuthContext } from "../../../hooks/useAuthContext"

const { Link, Text } = Typography

export default function UnconfirmedPricesList(props) {
  const { user } = useAuthContext()

  //approves the price
  const updateData = async (e, docid, dokument) => {
    e.preventDefault()
    //price ref
    const ref = doc(db, "priceCalculation", docid)

    //notifications refference
    const notifRef = collection(db, "notifications")

    //Approve the price
    await updateDoc(ref, {
      aproved: true,
      date: {
        status: 1,
        lastEdit: serverTimestamp(),
        created: dokument.date.created,
      },
    })
      .then(() => {
        try {
          addDoc(notifRef, {
            date: serverTimestamp(),
            desc: `Admin ${user.email} has approved price "${dokument.product.productName}"`,
            seen: false,
            type: "Approved Price",
            uid: dokument.user,
            userEmail: dokument.userEmail,
            productId: dokument.id,
            productName: dokument.product.productName,
            clientId: dokument.clientId,
          })
        } catch (error) {
          Notification("error", "Login Error", error.message)
        }
      })
      .then(() => {
        Notification("success", "Updated!", "Price has been approved!")
      })
      .catch((err) => {
        Notification("error", "Login Error", err.message)
      })
  }

  //deleting the price
  const deleteData = async (e, docid, item) => {
    e.preventDefault()

    //notifications refference
    const notifRef = collection(db, "notifications")

    //price ref
    const ref = doc(db, "priceCalculation", docid)

    //deletes the price
    await deleteDoc(ref)
      .then(() => {
        Notification("warning", "Deleted!", "Price has been deleted!")
      })
      .then(() => {
        try {
          addDoc(notifRef, {
            date: serverTimestamp(),
            desc: `Admin ${user.email} has deleted the price "${item.product.productName}"`,
            seen: false,
            type: "Deleted Price",
            uid: item.user,
            userEmail: item.userEmail,
            productId: item.id,
            productName: item.product.productName,
            clientId: item.clientId,
          })
        } catch (error) {
          Notification("error", "Login Error", error.message)
        }
      })
      .catch((err) => {
        Notification("error", "Login Error", err.message)
      })
  }

  const popupContent = (prices) => (
    <div style={{ width: "250px" }}>
      <Descriptions size="small" column={2}>
        {prices.map((data) => (
          <>
            <Descriptions.Item contentStyle={{ color: "#1677ff" }} label="Quantity">
              {data.quantity}
            </Descriptions.Item>
            <Descriptions.Item contentStyle={{ color: "#52c41a" }} label="Price">
              {data.price}
            </Descriptions.Item>
          </>
        ))}
      </Descriptions>
    </div>
  )

  return (
    <div style={{ backgroundColor: "white" }}>
      <List
        size="small"
        loading={props.loading}
        itemLayout="horizontal"
        dataSource={props.loading ? "" : props.data}
        rowKey={(record) => record.id}
        renderItem={(item) => (
          <List.Item key={item.id}>
            <Descriptions
              key={item.id}
              style={{ width: "100%" }}
              labelStyle={{ fontStyle: "italic" }}
              contentStyle={{ color: "#1677ff" }}
              extra={[
                <Space key="extra-buttons">
                  <Button type="primary" onClick={(e) => updateData(e, item.id, item)}>
                    Approve Price <CheckOutlined />
                  </Button>
                  {/* LINK TO RE-Calculations */}
                  <Direction state={item} to={item.id}>
                    <Button type="primary" ghost>
                      Re-Calculate <RollbackOutlined />
                    </Button>
                  </Direction>
                  <Popconfirm
                    onConfirm={(e) => deleteData(e, item.id, item)}
                    title="Are you sure you want to delete?"
                    okText="Yes"
                    cancelText="No">
                    <Button disabled danger>
                      Delete
                      <CloseOutlined />
                    </Button>
                  </Popconfirm>
                </Space>,
              ]}
              title={"Client : " + item.client}
              size="small"
              column={{
                xxl: 4,
                xl: 3,
                lg: 3,
                md: 3,
                sm: 2,
                xs: 1,
              }}>
              {/* MACHINE */}
              <Descriptions.Item label="Machine">{item.machine}</Descriptions.Item>

              {/*  CMYK COLOR */}
              <Descriptions.Item label={item.print.cmykColors > 0 ? "CMYK" : ""}>
                {item.print.cmykColors > 0 ? (
                  <>
                    {item.print.cmykColors}
                    <Divider type="vertical" />
                    <Progress steps={5} status="normal" percent={item.print.cmykPercent * 100} />
                  </>
                ) : (
                  ""
                )}
              </Descriptions.Item>

              {/* PRICE */}
              <Descriptions.Item label="Price">
                {item.advanced.fixedPrice ? (
                  <>
                    <Space>
                      <Text type="danger">{item.totalFixedPrice}</Text>
                      <Text code italic type="danger">
                        Fixed
                      </Text>
                    </Space>
                  </>
                ) : (
                  <>
                    <Popover
                      content={popupContent(item.dynamicPrice)}
                      title={item.product.productName}
                      trigger="click">
                      <Link>View</Link>
                    </Popover>
                  </>
                )}
              </Descriptions.Item>

              {/* PRODUCT NAME */}
              <Descriptions.Item label="Product">{item.product.productName}</Descriptions.Item>

              {/* PANTONE COLORS */}
              <Descriptions.Item label={item.print.pantoneColors > 0 ? "Pantone" : ""}>
                {item.print.pantoneColors > 0 ? (
                  <>
                    {item.print.pantoneColors}
                    <Divider type="vertical" />
                    <Progress steps={5} status="normal" percent={item.print.pantonePercent * 100} />
                  </>
                ) : (
                  ""
                )}
              </Descriptions.Item>

              {/* FIXED PRICE */}

              <Descriptions.Item label="Fixed Price?">
                {item.advanced.fixedPrice ? (
                  <>
                    <Text type="danger">Yes</Text>
                  </>
                ) : (
                  "No"
                )}
              </Descriptions.Item>

              {/* LABEL COUNT */}
              <Descriptions.Item label="Label Count">{item.labelCount}</Descriptions.Item>

              {/* COWERING W COUNT */}
              <Descriptions.Item label={item.print.coveringWCount > 0 ? "White" : ""}>
                {item.print.coveringWCount > 0 ? (
                  <>
                    {item.print.coveringWCount}
                    <Divider type="vertical" />
                    <Progress
                      steps={5}
                      status="normal"
                      percent={item.print.coveringWPercent * 100}
                    />
                  </>
                ) : (
                  ""
                )}
              </Descriptions.Item>

              {/* EXTRA PROFIT */}
              {item.advanced.extraProfit !== 0 ? (
                <Descriptions.Item label="Extra Profit">
                  {item.advanced.extraProfit}%
                </Descriptions.Item>
              ) : (
                <Descriptions.Item label="Extra Profit"> 0%</Descriptions.Item>
              )}

              {/* Knife */}
              <Descriptions.Item label="Knife">{item.knifeCode}</Descriptions.Item>

              {/* VARNISH */}
              <Descriptions.Item label={item.print.varnishType !== "none" ? "Varnish" : ""}>
                {item.print.varnishType !== "none" ? (
                  <>
                    {item.print.varnishType}
                    <Divider type="vertical" />
                    <Progress steps={5} status="normal" percent={item.print.varnishPercent * 100} />
                  </>
                ) : (
                  ""
                )}
              </Descriptions.Item>

              {/* CLIENTS PROFIT */}
              <Descriptions.Item label="Client's profit">{item.clientsProfit}%</Descriptions.Item>

              {/* WIDTH/ HEIGHT */}
              <Descriptions.Item label="Width/Height">
                {item.labelWidth} | {item.labelHeight}
              </Descriptions.Item>

              {/* GOLD OR SILVER */}
              <Descriptions.Item label={item.print.goldOrSilver > 0 ? "Silver/Gold" : ""}>
                {item.print.goldOrSilver > 0 ? (
                  <>
                    {item.print.goldOrSilver}
                    <Divider type="vertical" />
                    <Progress
                      steps={5}
                      status="normal"
                      percent={item.print.goldOrSilverPercent * 100}
                    />
                  </>
                ) : (
                  ""
                )}
              </Descriptions.Item>

              {/* USER EMAIL */}
              <Descriptions.Item label="User">{item.userEmail}</Descriptions.Item>

              {/* MATERIAL */}
              <Descriptions.Item label="Material">{item.material}</Descriptions.Item>

              {/* RELIEF */}
              <Descriptions.Item label={item.print.relief === "Yes" ? "Relief" : ""}>
                {item.print.relief === "Yes" ? item.print.relief : ""}
              </Descriptions.Item>

              {/* CREATED */}
              <Descriptions.Item label="Created">
                {moment.unix(item.date.created.seconds && item.date.created.seconds).format("L")}
              </Descriptions.Item>

              {/* FORMAT */}
              <Descriptions.Item label="Format">
                {item.formatWidth} | Cols: {item.numberOfColumns}
              </Descriptions.Item>

              {/* FOIL */}
              <Descriptions.Item label={item.print.foilCount > 0 ? "Foil" : ""}>
                {item.print.foilCount > 0 ? (
                  <>
                    {item.print.foilColor}
                    <Divider type="vertical" />
                    <Progress steps={5} status="normal" percent={item.print.foilPercent * 100} />
                  </>
                ) : (
                  ""
                )}
              </Descriptions.Item>

              {/* FILE URL */}
              {item.product.productFileUrl ? (
                <Descriptions.Item label="Product File">
                  <Link target="_blank" href={item.product.productFileUrl}>
                    <Space>
                      <FileOutlined />
                      View File
                    </Space>
                  </Link>
                </Descriptions.Item>
              ) : (
                <></>
              )}
            </Descriptions>
          </List.Item>
        )}
      />
    </div>
  )
}
